// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.todolist-page {
  padding: 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.header-actions {
  display: flex;
  gap: 20px;
  align-items: center;
}

.view-selector {
  display: flex;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.03);
  padding: 0.4rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.view-selector button {
  padding: 0.6rem 1.2rem;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  color: rgba(226, 232, 240, 0.7);
  font-weight: 500;
}

.view-selector button:hover {
  background: rgba(99, 102, 241, 0.1);
  color: var(--white);
}

.view-selector button.active {
  background: linear-gradient(120deg, var(--secondary-color), var(--primary-color));
  color: var(--white);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.category-filter {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
}

.category-select {
  flex: 1 1;
  max-width: 300px;
  padding: 8px 12px;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  font-size: 14px;
  color: var(--white);
}

/* Todo Form - Uses glass-panel from design system */
.todo-form {
  /* Inherits from .glass-panel */
  margin-bottom: 2rem;
}

.todo-form h2 {
  margin: 0;
  font-size: 1.6rem;
  color: var(--text-primary, #e2e8f0);
}

/* Todo Modal */
.todo-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(2, 6, 23, 0.75);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.todo-modal {
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.98), rgba(15, 23, 42, 0.98));
  border: 1px solid rgba(99, 102, 241, 0.25);
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6),
              0 0 0 1px rgba(255, 255, 255, 0.04),
              inset 0 1px 0 rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  overflow-y: auto;
  margin: 0 !important;
  padding: 0;
}

.todo-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
  border-radius: 18px 18px 0 0;
}

.todo-modal-close {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(226, 232, 240, 0.7);
  width: 36px;
  height: 36px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  transition: all 0.2s;
}

.todo-modal-close:hover {
  background: rgba(239, 68, 68, 0.15);
  border-color: rgba(239, 68, 68, 0.3);
  color: #fca5a5;
}

.todo-modal form {
  padding: 28px 32px 24px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  margin-bottom: 6px;
  color: #4b5563;
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  background: rgba(15, 23, 42, 0.6);
  color: var(--white);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.form-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

/* Category Form Modal */
.category-form-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Category Form - Uses glass-panel */
.category-form {
  /* Inherits from .glass-panel via class in JSX */
  padding: 25px;
  width: 400px;
  max-width: 90%;
}

.category-form h3 {
  margin-bottom: 20px;
}

/* Todos Container */
.todos-container {
  margin-top: 20px;
}

/* Todo Group - Uses glass-panel from design-system.css */
.todo-group {
  /* Inherits from .glass-panel via class in JSX */
  margin-bottom: 30px;
  padding: 20px;
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.group-header h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1f2937;
  font-size: 1.125rem;
}

.todo-count {
  color: #6b7280;
  font-weight: normal;
  font-size: 0.875rem;
}

.todos-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
}

/* Todo Item */
.todo-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.2s;
}

.todo-item:hover {
  background: rgba(99, 102, 241, 0.08);
  border-color: rgba(99, 102, 241, 0.2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.todo-item.completed {
  opacity: 0.7;
}

.todo-item.overdue {
  border-left: 3px solid #ef4444;
}

.todo-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.todo-content {
  flex: 1 1;
}

.todo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.todo-header h4 {
  margin: 0;
  color: #1f2937;
  font-size: 1rem;
}

.todo-header h4.completed-text {
  text-decoration: line-through;
  color: #9ca3af;
}

.priority-badge {
  font-size: 1.25rem;
}

.todo-description {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 5px 0;
}

.todo-meta {
  display: flex;
  gap: 15px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.todo-meta span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  color: #6b7280;
}

.due-date {
  color: #6b7280;
}

.due-date.today {
  color: #3b82f6;
  font-weight: 500;
}

.due-date.overdue {
  color: #ef4444;
  font-weight: 500;
}

.assigned-to {
  color: #6b7280;
}

.category-badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 500;
}

.todo-actions {
  display: flex;
  gap: 5px;
}

.btn-icon {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-icon.edit {
  background: #3b82f6;
  color: white;
}

.btn-icon.edit:hover {
  background: #2563eb;
}

.btn-icon.delete {
  background: #ef4444;
  color: white;
}

.btn-icon.delete:hover {
  background: #dc2626;
}

/* Empty State */
.no-todos {
  text-align: center;
  padding: 60px 20px;
  color: #9ca3af;
}

.no-todos svg {
  font-size: 3rem;
  margin-bottom: 10px;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #6b7280;
}

/* Buttons */
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.btn-primary {
  background: #3b82f6;
  color: white;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-secondary {
  background: #6b7280;
  color: white;
}

.btn-secondary:hover {
  background: #4b5563;
}

.btn-success {
  background: #10b981;
  color: white;
}

.btn-success:hover {
  background: #059669;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .header-actions {
    width: 100%;
    flex-direction: column;
    gap: 10px;
  }
  
  .view-selector {
    width: 100%;
    justify-content: space-between;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .todo-item {
    flex-direction: column;
  }
  
  .todo-actions {
    align-self: flex-end;
  }
}
/* Quick Add Form */
.quick-add-form {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 25px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.quick-add-inner {
  display: flex;
  gap: 15px;
  align-items: center;
}

.quick-add-input {
  flex: 1 1;
  padding: 14px 18px;
  border: 2px solid transparent;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s;
}

.quick-add-input:focus {
  outline: none;
  border-color: #10B981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.quick-add-input::placeholder {
  color: #9CA3AF;
}

.quick-add-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}

.quick-add-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.quick-add-btn {
  background: #10B981;
  color: white;
  padding: 14px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
}

.quick-add-btn:hover {
  background: #059669;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
}

.quick-add-btn:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .quick-add-inner {
    flex-direction: column;
    align-items: stretch;
  }

  .quick-add-checkbox {
    justify-content: center;
  }

  .quick-add-btn {
    justify-content: center;
  }
}

/* ============ LIGHT THEME OVERRIDES ============ */
[data-theme="light"] .todo-item,
[data-theme="light"] .add-todo-form {
  color: #1e293b;
}

[data-theme="light"] .todo-text {
  color: #1e293b;
}

[data-theme="light"] .add-todo-input {
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b;
  border: 1px solid rgba(15, 23, 42, 0.15);
}

[data-theme="light"] .add-todo-input:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/features/todos/TodoList.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,iFAAiF;EACjF,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mFAAmF;EACnF,0CAA0C;EAC1C;;qDAEmD;EACnD,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;EAClD,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE,gDAAgD;EAChD,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,gDAAgD;EAChD,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;AACF;AACA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,oDAAoD;AACpD;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD","sourcesContent":[".todolist-page {\n  padding: 0;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.page-header h1 {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.header-actions {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.view-selector {\n  display: flex;\n  gap: 0.5rem;\n  background: rgba(255, 255, 255, 0.03);\n  padding: 0.4rem;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.view-selector button {\n  padding: 0.6rem 1.2rem;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s;\n  color: rgba(226, 232, 240, 0.7);\n  font-weight: 500;\n}\n\n.view-selector button:hover {\n  background: rgba(99, 102, 241, 0.1);\n  color: var(--white);\n}\n\n.view-selector button.active {\n  background: linear-gradient(120deg, var(--secondary-color), var(--primary-color));\n  color: var(--white);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);\n}\n\n.category-filter {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 20px;\n  padding: 15px;\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n}\n\n.category-select {\n  flex: 1;\n  max-width: 300px;\n  padding: 8px 12px;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 6px;\n  font-size: 14px;\n  color: var(--white);\n}\n\n/* Todo Form - Uses glass-panel from design system */\n.todo-form {\n  /* Inherits from .glass-panel */\n  margin-bottom: 2rem;\n}\n\n.todo-form h2 {\n  margin: 0;\n  font-size: 1.6rem;\n  color: var(--text-primary, #e2e8f0);\n}\n\n/* Todo Modal */\n.todo-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(2, 6, 23, 0.75);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.todo-modal {\n  background: linear-gradient(135deg, rgba(30, 41, 59, 0.98), rgba(15, 23, 42, 0.98));\n  border: 1px solid rgba(99, 102, 241, 0.25);\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6),\n              0 0 0 1px rgba(255, 255, 255, 0.04),\n              inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  border-radius: 18px;\n  width: 100%;\n  max-width: 900px;\n  max-height: 90vh;\n  overflow-y: auto;\n  margin: 0 !important;\n  padding: 0;\n}\n\n.todo-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n  border-radius: 18px 18px 0 0;\n}\n\n.todo-modal-close {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  color: rgba(226, 232, 240, 0.7);\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  transition: all 0.2s;\n}\n\n.todo-modal-close:hover {\n  background: rgba(239, 68, 68, 0.15);\n  border-color: rgba(239, 68, 68, 0.3);\n  color: #fca5a5;\n}\n\n.todo-modal form {\n  padding: 28px 32px 24px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  margin-bottom: 6px;\n  color: #4b5563;\n  font-size: 0.875rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 8px 12px;\n  background: rgba(15, 23, 42, 0.6);\n  color: var(--white);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n.form-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n/* Category Form Modal */\n.category-form-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Category Form - Uses glass-panel */\n.category-form {\n  /* Inherits from .glass-panel via class in JSX */\n  padding: 25px;\n  width: 400px;\n  max-width: 90%;\n}\n\n.category-form h3 {\n  margin-bottom: 20px;\n}\n\n/* Todos Container */\n.todos-container {\n  margin-top: 20px;\n}\n\n/* Todo Group - Uses glass-panel from design-system.css */\n.todo-group {\n  /* Inherits from .glass-panel via class in JSX */\n  margin-bottom: 30px;\n  padding: 20px;\n}\n\n.group-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.group-header h3 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #1f2937;\n  font-size: 1.125rem;\n}\n\n.todo-count {\n  color: #6b7280;\n  font-weight: normal;\n  font-size: 0.875rem;\n}\n\n.todos-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 10px;\n}\n\n/* Todo Item */\n.todo-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n  padding: 15px;\n  background: rgba(255, 255, 255, 0.02);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  transition: all 0.2s;\n}\n\n.todo-item:hover {\n  background: rgba(99, 102, 241, 0.08);\n  border-color: rgba(99, 102, 241, 0.2);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.todo-item.completed {\n  opacity: 0.7;\n}\n\n.todo-item.overdue {\n  border-left: 3px solid #ef4444;\n}\n\n.todo-checkbox input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.todo-content {\n  flex: 1;\n}\n\n.todo-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.todo-header h4 {\n  margin: 0;\n  color: #1f2937;\n  font-size: 1rem;\n}\n\n.todo-header h4.completed-text {\n  text-decoration: line-through;\n  color: #9ca3af;\n}\n\n.priority-badge {\n  font-size: 1.25rem;\n}\n\n.todo-description {\n  color: #6b7280;\n  font-size: 0.875rem;\n  margin: 5px 0;\n}\n\n.todo-meta {\n  display: flex;\n  gap: 15px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.todo-meta span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.due-date {\n  color: #6b7280;\n}\n\n.due-date.today {\n  color: #3b82f6;\n  font-weight: 500;\n}\n\n.due-date.overdue {\n  color: #ef4444;\n  font-weight: 500;\n}\n\n.assigned-to {\n  color: #6b7280;\n}\n\n.category-badge {\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.todo-actions {\n  display: flex;\n  gap: 5px;\n}\n\n.btn-icon {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.btn-icon.edit {\n  background: #3b82f6;\n  color: white;\n}\n\n.btn-icon.edit:hover {\n  background: #2563eb;\n}\n\n.btn-icon.delete {\n  background: #ef4444;\n  color: white;\n}\n\n.btn-icon.delete:hover {\n  background: #dc2626;\n}\n\n/* Empty State */\n.no-todos {\n  text-align: center;\n  padding: 60px 20px;\n  color: #9ca3af;\n}\n\n.no-todos svg {\n  font-size: 3rem;\n  margin-bottom: 10px;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #6b7280;\n}\n\n/* Buttons */\n.btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s;\n}\n\n.btn-primary {\n  background: #3b82f6;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #2563eb;\n}\n\n.btn-secondary {\n  background: #6b7280;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #4b5563;\n}\n\n.btn-success {\n  background: #10b981;\n  color: white;\n}\n\n.btn-success:hover {\n  background: #059669;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n  \n  .header-actions {\n    width: 100%;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .view-selector {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .todo-item {\n    flex-direction: column;\n  }\n  \n  .todo-actions {\n    align-self: flex-end;\n  }\n}\n/* Quick Add Form */\n.quick-add-form {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 25px;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.quick-add-inner {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.quick-add-input {\n  flex: 1;\n  padding: 14px 18px;\n  border: 2px solid transparent;\n  border-radius: 8px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s;\n}\n\n.quick-add-input:focus {\n  outline: none;\n  border-color: #10B981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);\n}\n\n.quick-add-input::placeholder {\n  color: #9CA3AF;\n}\n\n.quick-add-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  user-select: none;\n}\n\n.quick-add-checkbox input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.quick-add-btn {\n  background: #10B981;\n  color: white;\n  padding: 14px 24px;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.quick-add-btn:hover {\n  background: #059669;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);\n}\n\n.quick-add-btn:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 768px) {\n  .quick-add-inner {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .quick-add-checkbox {\n    justify-content: center;\n  }\n\n  .quick-add-btn {\n    justify-content: center;\n  }\n}\n\n/* ============ LIGHT THEME OVERRIDES ============ */\n[data-theme=\"light\"] .todo-item,\n[data-theme=\"light\"] .add-todo-form {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .todo-text {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .add-todo-input {\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e293b;\n  border: 1px solid rgba(15, 23, 42, 0.15);\n}\n\n[data-theme=\"light\"] .add-todo-input:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
